import { render, staticRenderFns } from "./sale-banner.vue?vue&type=template&id=0d297c14&"
import script from "./sale-banner.vue?vue&type=script&lang=js&"
export * from "./sale-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports